import { logger } from '@garnish/logger';

// ─────────────────────────────────────────────────────────────────────────────

export const log = logger.extend('Radar');
